<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="top">
          <!-- <div class="top-item">
            <span>筛选条件</span>
            <el-input placeholder="电话或订单号" v-model.trim="orderCondition" clearable size="small"></el-input>
          </div> -->
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker v-model="orderTime" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" size="small" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="top-item">
            <el-button type="primary" size="small" @click="screenOrder">筛选</el-button>
            <el-button @click="resetScreenData" size="small">重置</el-button>
            <el-button type="success" @click="openCheckCode()" size="small">核销</el-button>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-for="item in orderClassifyList" :key="String(item.orderStatus)" :label="String(item.orderNum)" :name="String(item.orderStatus)">
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
              <el-badge v-if="
                item.orderNum &&
                (item.orderStatus == -21 ||
                  item.orderStatus == 10 ||
                  item.orderStatus == 20)
              " :value="item.orderNum" class="item"></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoad">
          <div class="order-list" v-if="orderList.length">
            <ul>
              <li v-for="(item, index) in orderList" :key="item.tradeNo">
                <div class="item">
                  <div class="list-header">
                    <span class="order-num">#{{ item.orderNum }}</span>
                    <!-- <span class="order-no">
                      订单号：{{ item.id }}
                      <input style="position: absolute; top: 0; left: 0" :value="item.tradeNo" :class="`order-no${index}`" />
                    </span>
                    <el-button type="text" @click="copyOrderNo(index)">复制</el-button> -->
                  </div>
                  <div class="list-container">
                    <div class="products">
                      <div class="products-item" v-for="(productItem, itemIndex) in JSON.parse(item.mtYfCoupon).result" :key="itemIndex">
                        <div class="info">
                          <img :src="productItem.goodsImage || defaultImg" alt />
                          <div>
                            <p class="" :title="productItem.goodsName">
                              {{ productItem.dealTitle }}
                            </p>
                            <!-- <p class="desc" v-if="productItem.specDesc" :title="productItem.specDesc">
                              （{{ productItem.specDesc }}）
                            </p> -->
                            <p class="price">
                              ￥{{ Number(productItem.dealPrice).toFixed(2) }}
                            </p>
                          </div>
                        </div>
                        <div class="num">X {{ JSON.parse(item.mtYfCoupon).verifyCount }}</div>
                        <div class="price">
                          ￥{{ Number(JSON.parse(item.mtYfCoupon).payAmount / 100).toFixed(2) }}
                        </div>
                      </div>
                    </div>
                    <div class="time">
                      <div class="time-item">
                        <p>创建时间：{{ item.usedTime }}</p>
                      </div>
                    </div>
                    <div class="info">
                      <!-- <div>
                        <p class="address">{{ item.buyerName }} {{ item.buyerPhone }}</p>
                        <p class="address">{{ item.buyerAddress }}</p>
                      </div> -->
                      <p class="">券号：{{ item.cashCouponCode }}</p>
                    </div>
                    <div class="action" v-if="orderType[item.orderStatus]">
                      <p :class="orderType[item.orderStatus].class">
                        {{ orderType[item.orderStatus].title }}
                      </p>
                      <p>
                        <el-button size="small" type="primary" v-if="orderType[item.orderStatus].btn" @click="
                          handleOrder(
                            item.mallOrderId,
                            item.orderStatus,
                            item.totalRetailPrice,
                            item.entryType
                          )
                          ">{{ orderType[item.orderStatus].btn }}</el-button>
                      </p>
                      <el-button v-show="(item.orderStatus == 30 ||
                        item.orderStatus == 40 ||
                        item.orderStatus == -21) &&
                        shopInfo.edcShopType == 2
                        " class="check-logistics" size="small" type="primary" plain @click="getLogisticsInfo(item.mallOrderId)">查看物流</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="list-none">
              <p>暂无更多数据</p>
            </div>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNo" background layout="prev, pager, next, jumper" :total="pageCount"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="发货" :visible.sync="isShowDeliverGoodsPop" width="30%">
      <div class="dialog-body">
        <el-select placeholder="请选择快递公司" v-model="sendCompanyId" style="margin-bottom: 10px">
          <el-option v-for="item in expressCompanyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input placeholder="请输入单号" v-model="oddNumbers"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDeliverGoodsPop = false">取 消</el-button>
        <el-button type="primary" @click="deliverGoodsConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="isShowLogisticsInfo" width="496px" v-if="isShowLogisticsInfo">
      <div class="logistics-dialog">
        <div class="logistics-header">
          <img class="icon" src="../assets/img/order/icon-ele.png" alt="" />
          <div class="info">
            <div class="name">
              快递公司：<strong>{{ logisticsInfo.expressInfo.name }}</strong>
            </div>
            <div class="phonenum">快递单号：{{ logisticsInfo.LogisticCode }}</div>
          </div>
        </div>
        <div class="logistics-body">
          <div class="el-steps-oem">
            <div class="el-step-oem active" v-for="(item, index) in logisticsInfo.Traces" :key="item.id">
              <div class="index">{{ logisticsInfo.Traces.length - index }}</div>
              <div class="title" :class="{
                active:
                  logisticsInfo.Traces.length - index == logisticsInfo.Traces.length,
              }">
                {{ item.Remark }}
              </div>
              <div class="desc">
                {{ item.AcceptStation }}
              </div>
              <div class="time">{{ item.AcceptTime }}</div>
            </div>
          </div>
          <!-- <el-steps direction="vertical" :active="logisticsInfo.status.length">
            <el-step v-for="item in logisticsInfo.status" :key="item.id">
              <div slot="description">
                <div class="title">
                  {{ logisticsInfoText[item.orderStatus].title }}
                </div>
                <div class="desc">
                  {{ logisticsInfoText[item.orderStatus].desc }}
                </div>
                <div class="time">{{ item.modifyTime }}</div>
              </div>
            </el-step>
          </el-steps> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog title="请扫描核销码" :visible.sync="isShowCheck" width="496px" :before-close="handleClose">
      <div class="check-code">
        <span class="check-code-title">核销码</span>
        <el-input v-model="checkCode" placeholder="请输入核销码" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findMtYfCouponList,
  handleOrder,
  createReundOrder,
  getExpressCompany,
  sendDSOrder,
  orderExpress,
  verifyMtYfCoupon,
} from "@/api";
import md5 from "js-md5";
import { mapState } from "vuex";
import { createScannerInput } from "@/utils/scannerInput";

let params = null;
let orderList = null;

export default {
  data() {
    return {
      orderCondition: "",
      activeName: "all",
      pageCount: 0,
      orderCategory: "",
      orderTime: [],
      startDate: "",
      endDate: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pageNo: 1,
      pageSize: 5,
      orderList: [],
      isLoad: false,
      orderType: {
        10: {
          title: "待付款",
          class: "black",
          // btn: "确认买单",
        },
        20: {
          title: "待发货",
          class: "red",
          btn: "确认发货",
        },
        // 20: {
        //   title: "待核销",
        //   class: "red",
        //   btn: "核销",
        // },
        30: {
          title: "待确认",
          class: "black",
        },
        31: {
          title: "待买单",
          class: "black",
          //   btn: "确认买单",
        },
        35: {
          title: "待评论",
          class: "black",
        },
        40: {
          title: "已完成",
          class: "black",
          //   btn: "退款",
        },
        "-10": {
          title: "已关闭",
          class: "red",
        },
        "-20": {
          title: "已取消",
          class: "red",
        },
        "-21": {
          title: "申请退款",
          class: "red",
          btn: "手动退款",
        },
        "-50": {
          title: "退款",
          class: "black",
        },
        "-60": {
          title: "未成团",
          class: "black",
        },
      },
      defaultImg: require("../assets/img/common/default-img.jpg"),
      // 发货信息
      expressCompanyList: [],
      isShowDeliverGoodsPop: false,
      oddNumbers: "",
      sendCompanyId: "",
      mallOrderId: "",
      isShowLogisticsInfo: false,
      logisticsInfo: {},

      isShowCheck: false, // 显示核销弹框
      checkCode: "", // 核销码
    };
  },
  watch: {
    activeName(status) {
      console.log(status);
      this.orderClassifyList.forEach((val) => {
        if (val.orderStatus == status) {
          this.pageCount = val.orderNum;
        }
      });
      this.pageNo = 1;
      this.getPageData();
    },
    currentPage(v) {
      this.activeName = "all";
      this.getPageData();
    },
    orderTime(val) {
      this.startDate = val ? new Date(val[0]).pattern("yyyy-MM-dd") : "";
      this.endDate = val ? new Date(val[1]).pattern("yyyy-MM-dd") : "";
    },
    orderCondition(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    isShowDiscountPop(val) {
      if (!val) {
        this.discount = "";
        orderList = null;
        params = null;
      }
    },
    $route(to, from) {
      this.initPage();
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    orderClassifyList() {
      return [
        {
          orderStatusName: "全部订单",
          orderNum: 0,
          orderStatus: "all",
        },
        {
          orderStatusName: "未使用",
          orderNum: 0,
          orderStatus: 1,
        },
        {
          orderStatusName: "已使用",
          orderNum: 0,
          orderStatus: 2,
        },
        {
          orderStatusName: "退回",
          orderNum: 0,
          orderStatus: 3,
        },
      ];
    },
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      if (this.$route.params.tradeNo) {
        this.orderCondition = this.$route.params.tradeNo;
      }
      this.getPageData();
      this.getExpressCompany();
      this.checkCodeScanner = createScannerInput({
        getValue: () => this.checkCode,
        setValue: (value) => {
          this.checkCode = value;
        },
        getInput: () => this.getCheckCodeInput(),
        onEnter: async () => {
          const res = await verifyMtYfCoupon({
            code: this.checkCode,
          });
          if (res.code == 0) {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          } else if (res.code == 1) {
            this.$message({
              type: "success",
              message: "核销成功",
            });
          }
          this.checkCode = "";
        },
        readonlyOnScan: true,
        trapTab: true,
        submitOnEnterAlways: true,
      });
    },
    getCheckCodeInput() {
      if (this.$el) {
        return this.$el.querySelector(".check-code input");
      }
      return null;
    },
    focusCheckCodeInput() {
      if (!this.isShowCheck) {
        return;
      }
      this.$nextTick(() => {
        this.checkCodeScanner.focus();
      });
    },
    handleClose() {
      this.isShowCheck = false;
      this.checkCode = "";
      document.onkeydown = null;
      this.checkCodeScanner.reset();
    },
    // 打开核销弹框
    openCheckCode() {
      this.isShowCheck = true;
      this.checkCodeScanner.reset();
      this.focusCheckCodeInput();
      document.onkeydown = this.checkCodeScanner.handleKeydown;
    },
    // 查看物流
    getLogisticsInfo(mallOrderId) {
      orderExpress({
        mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.logisticsInfo = res.data;
          this.isShowLogisticsInfo = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 确认发货
    deliverGoodsConfirm() {
      // console.log(this.oddNumbers, this.sendCompanyId)
      if (!this.oddNumbers) {
        this.$notify({
          title: "提示",
          message: "请输入订单号",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      if (!this.sendCompanyId) {
        this.$notify({
          title: "提示",
          message: "请选择快递公司",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      sendDSOrder({
        mallOrderId: this.mallOrderId,
        sendCompanyId: this.sendCompanyId,
        expressNo: this.oddNumbers,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "发货成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
        this.isShowDeliverGoodsPop = false;
        this.mallOrderId = "";
        this.sendCompanyId = "";
      });
      this.isShowDeliverGoodsPop = false;
    },
    getPageData() {
      this.getAllOrders();
    },
    getAllOrders() {
      this.isLoad = true;
      findMtYfCouponList({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        usedStatus: this.activeName == "all" ? "" : this.activeName,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.code == 1) {
          this.orderList = res.data.list;
          this.pageCount = res.data.totalCount;
        } else if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoad = false;
      });
    },
    resetScreenData() {
      this.pageNo = 1;
      this.tablePositionValue = "all";
      this.orderTime = [];
      this.startDate = "";
      this.endDate = "";
      this.orderCondition = "";
      this.getPageData();
    },
    screenOrder() {
      this.pageNo = 1;
      this.getPageData();
    },
    handleSizeChange() { },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    // 获取快递公司
    getExpressCompany() {
      getExpressCompany().then((res) => {
        if (res.code == 1) {
          this.expressCompanyList = res.data;
        }
      });
    },
    handleOrder(mallOrderId, orderStatus, payMoney, entryType) {
      console.log(orderStatus);
      let nextOrderStatus = 0;
      if (orderStatus == 19) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 20) {
        nextOrderStatus = 30;
        if (this.shopInfo.edcShopType == 2) {
          this.mallOrderId = mallOrderId;
          this.isShowDeliverGoodsPop = true;
          return;
        }
      }
      if (orderStatus == 31) {
        nextOrderStatus = 40;
      }
      if (orderStatus == 10) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 40 || orderStatus == -21) {
        nextOrderStatus = -50;
        if (entryType != 3 && entryType != 4) {
          this.$prompt("请输入密码", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputType: "password",
          }).then(({ value }) => {
            createReundOrder({
              managerPassWord: String(md5(value)).toUpperCase(),
              mallOrderId: mallOrderId,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "退款成功",
                  type: "success",
                  duration: 1000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          });
          return;
        }
      }
      this.handleOrderFuc(mallOrderId, nextOrderStatus);
    },
    handleOrderFuc(mallOrderId, nextOrderStatus) {
      handleOrder({
        mallOrderId: mallOrderId,
        orderStatus: nextOrderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        }
      });
    },
    // 复制订单号
    copyOrderNo(index) {
      var copyText = document.querySelector(`.order-no${index}`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
  }

  .tab-header {
    .top {
      display: flex;

      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;

        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }

        .el-select {
          width: 100%;
        }
      }
    }
  }

  .tab-content {
    display: block;
    padding: 20px;

    .order-list {
      .item {
        border: 1px solid #eeeeee;
        margin-bottom: 20px;

        .list-header {
          background: #f8f8f8;
          height: 48px;
          line-height: 48px;
          padding-left: 18px;

          .order-num {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 10px;
          }

          .delivery-time {
            font-size: 12px;
            color: #f57878;
            margin-right: 10px;
          }

          .suggest,
          .order-no {
            font-size: 12px;
            color: #666666;
          }

          .suggest {
            margin-right: 28px;
          }

          .order-no {
            margin-right: 10px;
          }
        }

        .list-container {
          display: flex;

          &>div {
            border-right: 1px solid #eee;

            &:last-child {
              border-right: 0;
            }
          }

          .products {
            flex: 3.63;

            &>div:last-of-type {
              &>.products-item:last-of-type {
                border-bottom: 0;
              }
            }

            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;

            &>div {
              width: 100%;
            }

            .products-item {
              display: flex;
              height: 70px;
              box-sizing: border-box;
              align-items: center;
              border-bottom: 1px solid #eee;

              &:last-child {
                border-bottom: 0;
              }

              .info {
                flex: 5.3;
                display: flex;
                align-items: center;

                img {
                  width: 50px;
                  height: 50px;
                  margin: 0 10px 0 18px;
                }

                .price {
                  font-size: 12px;
                  line-height: 26px;
                  color: #666666;
                }

                .name {
                  font-size: 12px;
                  line-height: 28px;
                  color: #333333;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                .desc {
                  font-size: 12px;
                  line-height: 16px;
                  color: #666;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }

              .num {
                flex: 1.46;
                font-size: 12px;
                color: #333333;
                font-weight: bold;

                .num-type {
                  display: inline-block;
                  border: 1px solid;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  line-height: 22px;
                  box-sizing: border-box;
                  width: 36px;
                  height: 24px;

                  &.retreat {
                    border-color: #fde2e2;
                    background-color: #fef0f0;
                    color: #f57878;
                  }

                  &.give {
                    border-color: #faecd8;
                    background-color: #fdf6ec;
                    color: #e6a45d;
                  }
                }
              }

              .price {
                flex: 2.11;
                width: 130px;
                font-size: 12px;
                color: #666666;
              }

              .action {
                flex: 1.11;
              }
            }
          }

          .time {
            flex: 0.87;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .time-item {
              font-size: 12px;
              color: #999999;
              line-height: 22px;
            }
          }

          &>.info {
            position: relative;
            flex: 1.95;
            padding: 32px 10px 10px 15px;
            font-size: 14px;
            line-height: 1;

            .takeoutinfo {
              margin-bottom: 14px;
            }

            .address {
              margin-bottom: 24px;
            }

            .tanginfo {
              color: #333333;

              .position {
                font-weight: bold;
              }

              margin-bottom: 20px;
            }

            .mark {
              color: #ee3030;
            }

            .icon-img {
              position: absolute;
              right: 10px;
              top: 10px;
            }
          }

          &>.price {
            flex: 1.58;
            text-align: center;
            padding-top: 31px;
            padding-bottom: 20px;
            line-height: 1;
            font-size: 14px;

            &>p:nth-of-type(1) {
              color: #333333;
              font-weight: bold;
              margin-bottom: 15px;
            }

            &>p:nth-of-type(2) {
              font-size: 12px;
              color: #999999;
              margin-bottom: 12px;
            }

            &>p:nth-of-type(3) {
              color: #ee3030;
              margin-bottom: 20px;
            }
          }

          .action {
            text-align: center;
            padding-top: 30px;
            padding-bottom: 20px;
            flex: 1;

            &>p:nth-of-type(1) {
              font-size: 14px;
              font-weight: bold;

              &.red {
                color: #ee3030;
              }

              &.black {
                color: #000;
              }
            }

            &>.el-button--primary {
              margin-top: 15px;
            }

            .el-button+.el-button {
              &.create-btn {
                display: block;
                margin-left: 0;
                margin: 10px auto 0;
              }

              margin-left: 2px;
            }

            .status-btn {
              display: block;
              margin-left: 0;
              margin: 10px auto 0;
            }
          }

          .print {
            text-align: center;
            padding-top: 20px;
            flex: 1;

            .check-logistics {
              display: block;
              margin: 10px auto 0;
            }
          }
        }
      }
    }

    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 20px;
    }
  }

  .el-dialog {
    .el-select {
      width: 100%;
    }
  }
}

.logistics-dialog {
  .logistics-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 6px;
    background: #f6fbff;
    padding: 14px 10px;

    .icon {
      width: 46px;
      height: 46px;
      margin-right: 10px;
    }

    .info {
      font-size: 12px;
      color: #409eff;
      line-height: 1;

      .name {
        margin-bottom: 8px;

        .tag {
          display: inline-block;
          padding: 3px 6px;
          background: #409eff;
          border-radius: 20px;
          border-bottom-left-radius: 0;
          font-size: 12px;
          line-height: 1;
          color: #fff;
          margin-left: 6px;
        }
      }
    }
  }

  .logistics-body {
    min-height: 500px;
    max-height: 500px;
    overflow: auto;
    margin-top: 22px;

    .el-steps-oem {
      padding: 10px;

      .el-step-oem {
        position: relative;
        padding-left: 40px;
        padding-bottom: 34px;

        &.active {
          &:not(:last-child)::before {
            background: #409eff;
          }

          .index {
            border-color: #409eff;
            color: #409eff;
          }
        }

        &:not(:last-child)::before {
          position: absolute;
          content: "";
          top: 0;
          bottom: 0;
          left: 12px;
          width: 2px;
          background: #c0c4cc;
        }

        .index {
          position: absolute;
          border: 2px solid #c0c4cc;
          height: 24px;
          width: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
          color: #c0c4cc;
          left: 0;
          top: -5px;
          border-radius: 50%;
          background: #fff;
          font-weight: bold;
        }

        .desc,
        .time {
          font-size: 12px;
          color: #666666;
        }

        .title {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          position: relative;
          top: -5px;

          &.active {
            color: #409eff;
          }
        }
      }
    }
  }
}

.check-code {
  display: flex;
  align-items: center;

  &-title {
    width: 50px;
    margin-right: 30px;
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}

.el-select-dropdown {
  width: 150px;
}
</style>
